import React from "react";

// import Samples from '../reuse/samples';


export default function Component(props){

  const channel_url = "https://api.lightflare.com/channels/<CHANNEL_ID>";
  return (
    <section id="code_samples" className=" content-container">
      <div className="container-fluid">
        <div className="container">

          <div className="my-3">
            <pre className="rounded" style={{whiteSpace: 'pre'}}>
              <code>
                <span className="">curl -X POST {channel_url} -H "Content-Type: application/json"</span>
                <br className=""/>
                <span className="">  -d '{"{"}"event_type": "app_restart", "event_meta": "user_service" {"}"}'</span>
              </code>              
            </pre>
            <div className="my-2 p-2 m-2">
              <h5 className="my-3">Why POST?</h5>
              <p className="">
                We allow metadata to be sent in the request body. 
                This is used to slice and dice logs and customize the notifications to be sent. 
                More on this in our <a href="/documentation" className="">documentation</a>!
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
    )
}
